import { render, staticRenderFns } from "./ReservationDetail.vue?vue&type=template&id=288aecda&scoped=true&lang=pug"
import script from "./ReservationDetail.vue?vue&type=script&lang=ts"
export * from "./ReservationDetail.vue?vue&type=script&lang=ts"
import style0 from "./ReservationDetail.vue?vue&type=style&index=0&id=288aecda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288aecda",
  null
  
)

export default component.exports